import { render } from "./RecibocampoView.vue?vue&type=template&id=43b72d29"
import script from "./RecibocampoView.vue?vue&type=script&lang=js"
export * from "./RecibocampoView.vue?vue&type=script&lang=js"

import "./RecibocampoView.vue?vue&type=style&index=0&id=43b72d29&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__